var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex"},[_c('v-spacer'),_c('img',{attrs:{"width":"250","src":require("@/assets/logo_red_medica.png")}}),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }